/* eslint-disable no-console */
export default {
    /**
     * Check if a product has deletion pending
     */
    isProductDeletionPending: state => productId =>
        state.productDeletionPending.includes(productId),
    filterPosts: state => id => {
        return state.products.sort(
            (a, b) => new Number(a.position) - new Number(b.position)
        );
    },

};